import {
  Card,
  CardContent,
  Grid,
  CardActions,
  Button,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Modal } from "../modal";
import { BubbleRobot } from "../robot";
import { ModalActions } from "../models/ModalActions";

interface Props {
  isOpen: boolean;
  text: string;
  children: React.ReactNode;
  actions?: ModalActions[];
  closeModal?: () => void;
}

const useStyles = makeStyles({
  root: {
    backgroundColor: "transparent",
  },
});

export const ModalRobot: React.FC<Props> = ({
  text,
  children,
  isOpen,
  closeModal = () => {},
  actions = [],
}) => {
  const classes = useStyles();

  const buttonActions = actions.map((action) => (
    <Grid item key={action.label}>
      <Button
        onClick={action.handler}
        color={!!action.color ? action.color : "default"}
        variant="contained"
      >
        {action.label}
      </Button>
    </Grid>
  ));

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      actions={[]}
      PaperProps={{
        classes,
        elevation: 0,
      }}
      fullScreen={true}
    >
      <Grid
        container
        direction="row"
        spacing={5}
        justify="center"
        alignItems="center"
      >
        <Grid item xs={4}>
          <BubbleRobot text={text}></BubbleRobot>
        </Grid>
        <Grid item xs={6}>
          <Card>
            <Box pl={6} pr={6} pt={4} pb={4}>
              <CardContent>{children}</CardContent>
              <CardActions>
                <Grid container direction="row" justify="flex-end" spacing={7}>
                  {buttonActions}
                </Grid>
              </CardActions>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Modal>
  );
};
